<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'concept-list.assign-manager'">_Asignar gestor</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <p class="common-modal__content-header-info"
      [afTranslate]="skin==='icam-red'?'concept-list.assign-manager-description':'concept-list.assign-manager-description-concept'"></p>
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-contacts
        [field]="assignManager.assignedManagerField"
        (sendContacts)="receiveContacts($event.contacts)"
        (contactsClosed)="contactsClosed()">
      </field-type-contacts>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer-container">
    <div class="common-modal__button-info-footer">
      <div class="common-badge__badge-block">
        <span class="common-badge__square-md">{{assignManager.countToShow}}</span>
      </div>
      <span class="common-modal__button-info-footer-text"
        [afTranslate]="skin==='icam-red'?'concept-list.query-selected':'concept-list.concepts-selected'"></span>
    </div>
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      <button class="common-button__text"
        (click)="verifyDestinationList()">
        <span class="common-button__text-title"
        [afTranslate]="'add-assignment.assign'">_Asignar</span>
      </button>
    </div>
  </div>
</div>
